import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getCurrentBoardId } from '../../../../../reducers/currentBoardId/currentBoardIdSelector';
import { createAndEditElement } from '../../../../../element/actions/elementActions';

// Components
import Icon from '../../../../../components/icons/Icon';
import ToolbarTool from '../../ToolbarTool';

// Types
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { ElementType } from '../../../../../../common/elements/elementTypes';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../../../../../common/elements/elementConstants';
import { BoardSections } from '../../../../../../common/boards/boardConstants';

type CommentToolProps = {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

const CommentTool = (props: CommentToolProps): ReactElement => {
    const { name, selectedElements } = props;
    const currentBoardId = useSelector(getCurrentBoardId);
    const dispatch = useDispatch();

    const addComment = () => {
        const element = selectedElements.first();
        const elementId = getElementId(element);

        dispatch(
            createAndEditElement({
                elementType: ElementType.COMMENT_THREAD_TYPE,
                creationSource: ELEMENT_CREATION_SOURCES.TOOLBAR,
                currentBoardId,
                location: {
                    parentId: elementId,
                    section: BoardSections.ATTACHED,
                    position: {
                        x: 'calc(100% - 2rem)',
                        y: '2rem',
                    },
                },
            }),
        );
    };

    return (
        <div className="CommentTool">
            <ToolbarTool {...props} name={name || 'Comment'} onClick={addComment}>
                <Icon name={`toolbar-comment`} />
            </ToolbarTool>
        </div>
    );
};

export default CommentTool;
